module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Italian Prince, Wedlocked Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_vm._v("CHAPTER ONE")])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("E’D")])])])])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("found her!")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Prince Maximo d’Aquilla parked his Mercedes beneath a broken streetlight, staring at the brightly lit gas station. The shining light from the shop’s windows illuminated the snowy night like a flame in the darkness, silhouetting the girl working alone inside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lucia Ferrazzi.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The granddaughter of his enemy. The ex-lover of his business rival.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Fate")])]), _vm._v(", he thought, gripping the steering wheel. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Il destino.")])]), _vm._v(" After all these years of looking, how else to explain it?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His phone rang. Ermanno, one of the bodyguards waiting in the car parked behind him, said a single word: "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Signore?”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wait for my signal,” Maximo replied in Italian, and snapped his phone shut.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He watched her for another five minutes. It was ten o’clock on New Year’s Eve, and the store should have been busy selling wine and beer; but the run-down South Chicago neighborhood was eerily dark and deserted beneath the heavily falling snow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl assisted her only customer at the cash register with a shy smile. Her scrubbed, clean face made her seem younger than twenty-one, he thought. Cat’seye glasses framed her wide-set brown eyes, giving her plain features a dowdy, bookish look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She would fall to him easily, he thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The solitary customer left, and a gray sedan skidded to a stop near the gas pumps. A thin man stepped out of the car. He stared at the girl, spraying breath freshener into his mouth, then started toward the store.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maximo saw the alarm in the girl’s eyes, the way she bit her tender pink lip as she watched the slender man come toward the door. She was afraid of him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maximo allowed himself a single, grim smile. She didn’t realize how much her world had changed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As of now, she was under Maximo’s protection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before the clock struck midnight, she would be his bride.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His revenge would be complete. And as for that other matter…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He pushed the thought firmly from his mind. It would all be over. He would take her, and in three months, he’d be free. Free—of everything.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("“Oh, no,” Lucy Abbott whispered aloud. The sound of her voice echoed in the empty store.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She leaned her head against the glass, watching as her smarmy manager came toward the door. She’d prayed she wouldn’t see him tonight. That he would have a date, a party, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("anything")])]), _vm._v(" to keep him from stopping by to “check on the store.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Just one more week")])]), _vm._v(", she reminded herself with a deep breath. One more week to put up with Darryl’s crude jokes, the way he stared at her breasts beneath her cashier’s smock, the way he would “accidentally” brush his groin against her hip amid the narrow aisles of chips and candy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d applied to be an assistant manager at a nearby store, and she needed his good reference until her position was finalized next week. Then Lucy could say goodbye to him forever. And even better, she would get a raise. For the first time since her baby had been born, she would be able to have just one job instead of three—she could work just forty hours a week instead of sixty. She’d be able to spend a few precious hours with her baby every single day.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Baby? Chloe wouldn’t be a baby much longer. Tomorrow was her first birthday. She could hardly believe it. In Lucy’s constant struggle to pay rent and medical bills and child care, she’d missed much of her daughter’s first year. She’d missed the first time her baby had rolled over, the first time she’d sat up by herself, the first time she’d crawled. She’d missed countless smiles and crying and happy jabbering…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Stop it")])]), _vm._v(", she ordered herself, angry at how close she was to tears. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Stop it right now.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Darryl burst through the door with a hard ring of the bell, bringing a blast of wind and snow behind him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, Luce,” Darryl said with a leer on his pink, rubbery lips. “Happy New Year.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Happy New Year,” she mumbled, hating that he called her "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Luce")])]), _vm._v(". It reminded her of the last man who’d called her that.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Busy tonight?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, very,” she lied over the lump in her throat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let me see.” She tried to flinch away, but he still managed to brush against her backside as he went behind the counter. He punched a few buttons on the cash register, then seeing the few dollars inside the tray, looked up at her accusingly. “Why, you little tease.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pretending to laugh, she backed from him. “It’s been busy, really! See the floors wet with tracked snow? I’d better get a mop…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Always such a busy little bee.” He sneered, stopping her with one bony, sinewy hand. “You really think you’re better than me, don’t you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, of course not, I—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Darryl grabbed her blue smock, looking down at her, breathing hard. “I’m tired of being nice to you for nothing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She heard the bell jingle above the door. But before she could look, he grabbed the back of her head, coming at her with his pink, rubbery lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What are you doing—let me go!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You act so prim,” he panted, “but you sleep around. You had that kid, didn’t you? I know you want me—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No,” she whimpered, struggling to turn her face away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Darryl yelped as a large hand grabbed him by the shoulder, spinning him around, yanking him backward like a dog on a leash.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucy gave a little cry as she saw a dark, towering figure pick up her manager by the lapels of his jacket. Darryl struggled futilely while the man, far taller and stronger than him, lifted him off the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The stranger’s eyes were hard and black. In a voice as cold and implacable as death, he growled into his face, “Get. Out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes,” Darryl gasped.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The giant tossed him to the floor. Her manager scrabbled back like a crab, tripping over his own feet in his eagerness to get away. He paused at the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re fired!” he bleated at Lucy, then rushed out into the snowy night, revving the engine of his old gray sedan down the dark street.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Fired?")])]), _vm._v(" She was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("fired")])]), _vm._v("? Her heart pounding, Lucy looked at her rescuer beneath the fluorescent overhead light.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The dark stranger looked down at her. His expressive eyes seared hers. He didn’t touch her. He didn’t have to. Just the heat of his glance made her tremble from deep within, as if he’d just woken something deep inside her…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you hurt, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("signorina")])]), _vm._v("?” His voice was accented and deep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had to lean back to see his face. She was five-six, not terribly petite, but the man still towered over her. His shoulders were impossibly broad, the lines of his long, black coat elegant and sharp, and his face…his face! Roman nose, high cheekbones. His blue eyes stood out against his olive skin. He had black, wavy hair, a darkly shadowed chin and crinkles at the edge of his eyes. Early thirties?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he took her breath away. The way he’d saved her—the way he looked at her now. She’d never known a man could be at once so beautiful and so strong. He was like a handsome prince out of a long-forgotten dream.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Signorina?”")])]), _vm._v(" His eyes were intense, searching as he reached over to touch her cheek. “If he hurt you—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She felt his brief touch like an explosion up and down her body. Her blood trembled as if she’d just thrown herself naked into a bed of snow. “No. I’m fine…I’m…” She sucked in her breath and repeated numbly, “I’m fired.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Fired.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No way to pay Mrs. Plotzky.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With no babysitter, she couldn’t go to her two part-time jobs. And since Chloe’s trip to the E.R. last month for croup, Lucy was already a month behind on her rent. Her landlord had threatened to throw her out on the street if she didn’t catch up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cold days stretched before her, Chicago’s icy wind wailing like a baby’s cry, and frigid, desperate nights scavenging beds at homeless shelters. She’d be destitute with her baby in the dead of winter, no job, no money, no home…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her baby. She’d failed her baby.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucy’s heart rose up in her throat, nearly choking her. Her lips soundlessly repeated her daughter’s name. Her knees trembled, her body shaking with a whole year of repressed grief and exhaustion. And everything started to go black…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man caught her before she could hit the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lifting her as if she weighed nothing, he held her against his chest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re done here,” he growled, and started carrying her toward the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Carrying her to the door?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She blinked up at him, feeling dazed and light-headed—and not just because of nearly fainting. Being close to this stranger, being cradled in his arms, did strange things to her heart rate. He was as darkly handsome as any hero from a novel. As he carried her past the counter, her eyes fell upon her battered paperback copy of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Wuthering Heights")])]), _vm._v(" poking out of her bag on the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But this dark, handsome stranger wasn’t Heathcliff. And she certainly wasn’t pampered, spoiled Cathy. Romantic tales had nothing to do with real life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d learned that the hard way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucy shook herself out of her reverie. “Where—where are you taking me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Out of here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Put me down!” Every insane man in Chicago seemed to be stopping by tonight—all of them intent on ruining her life! She kicked and struggled in his arms. “Let me "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("go")])]), _vm._v("!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Abruptly he released her, and she slid down his impossibly hard, impeccably dressed body. Her own body broke out in a cold sweat as she stood somewhat shakily on her own two feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I think the phrase you’re looking for,” the man said, “is "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("thank you")])]), _vm._v(".”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d been grateful to the man for saving her from Darryl’s advance, but now…What did Lucy care about some forced kiss, when her baby might soon have no home?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thank you?” she demanded furiously. “For what? For getting me "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("fired")])]), _vm._v("? I could have handled Darryl just fine if you hadn’t interfered!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Sì.”")])]), _vm._v(" His sensual mouth curved upward. “You obviously had the situation well in hand.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She ground her jaw. “You’re going to call him right now and tell him you’re sorry!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am sorry only that I didn’t use his face to mop your dirty floor.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she didn’t get her job back, she would be forced to take her baby to a homeless shelter. If all the shelters were full, which was likely during Chicago’s cold, hard winter, they’d have to live out of Lucy’s decrepit old hatchback, on the street, freezing…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("And it was all her fault for not doing a better job at protecting her daughter.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Terror ripped through her. “I need this job!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. You do not.” He looked down at her, so handsome, with the calm arrogance that only came from wealth. “You cannot pretend you took this job out of anything but desperation.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucy felt sick at his accurate appraisal of her situation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With no savings and few marketable skills, Lucy had worked at low-paying jobs since Chloe’s father had deserted them a week before her birth. She’d had to work constantly just to survive, since she’d foolishly given up her hard-won college scholarship to be with him. And he’d left Lucy with nothing but his baby in her belly and the memory of his whispered promises.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For the past year, she’d held their heads above water by such a thin margin. One mistake like this could suck them under. She couldn’t let them drown!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Please,” she whispered, though she knew it was hopeless. “You don’t know what will happen if I lose this job.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked down at her. Reaching out a broad, strong-fingered hand, he gently lifted her chin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You have nothing to fear ever again. You are mine now, Lucia. And I protect what is mine.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was his? What was he talking about?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then she realized what he’d called her: "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lucia.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How—how did you know my name?” Lucy stammered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know more about you than you can imagine.” He watched her beneath heavy-lidded eyes. “And I’m here to make your dreams come true.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Her dreams.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A snug, warm little house surrounded by sunshine and flowers. Her daughter growing up happy and secure. Having someone to love, instead of always being alone, fighting just to survive—")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pulling away from his touch, she angrily shook the images from her mind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My only dream is for you to call Darryl and beg for forgiveness.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His dark eyebrows rose. “That is indeed a fantasy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What did you think I would say? That my dream was to spend a night in your bed, having you make love to me for hours on end?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d meant to be sarcastic, but he gave her a hot glance that made her shiver, and wonder if her words were truer than she’d thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I offer you revenge,” he said. “Against the man who hurt you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I told you. Darryl didn’t do anything. You came before—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Alexander Wentworth,” he bit out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At the name, she felt the blood drain from her face. “What?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I will make him regret the day he abandoned you and your child to starve.” His blue eyes burned through her. “You are going to come with me to Italy, and live in luxury for the rest of your life.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e577d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italianprincewedlockedwife_ch01.vue
// module id = 75
// module chunks = 0